class Storage {
    key = 'enroll_storage';

    get() {
        let result = {
            caregiver_name:"",
            caregiver_tel:"",
            child:['','','boy'],
        };
        let saved = localStorage.getItem(this.key);
        if(!saved)
            return result;

        saved = JSON.parse(saved);
        return {result, ...saved};
    }

    set(params) {
        const result = {
            caregiver_name:params.caregiver_name,
            caregiver_tel:params.caregiver_tel,
            child:params.child,
        };

        localStorage.setItem(this.key, JSON.stringify(result));
    }
}

const enrollStorage = new Storage();

export default enrollStorage;